// extracted by mini-css-extract-plugin
export default {"table":"nZqRKl","dataRow":"eh9enN","noWithdrawals":"aiJhkA"};